<template>
  <el-row :gutter="15">
    <el-col :span="4" class="padding-r-0">
      <city-area-tree ref="cityAreaTree" @switchCityAreaTree="handleSwitchCityArea"></city-area-tree>
    </el-col>
    <el-col :span="20">
      <div class="white-bg padding-left padding-right padding-top border-radius-top">
        <div class="flex justify-between">
          <div class="text-title">
            {{ $t('cityArea.areaDetails') }}
          </div>
          <div></div>
        </div>

        <div class="margin-top">
          <el-form :model="cityAreaInfo" label-width="100px" class="text-left">
            <el-row>
              <el-col :sm="8" :xs="24">
                <el-form-item :label="$t('cityArea.areaName')">
                  <label>{{ cityAreaInfo.areaName || '-' }}</label>
                </el-form-item>
              </el-col>
              <el-col :sm="8" :xs="24">
                <el-form-item :label="$t('cityArea.areaCode')">
                  <label>{{ cityAreaInfo.areaCode || '-' }}</label>
                </el-form-item>
              </el-col>
              <el-col :sm="8" :xs="24">
                <el-form-item :label="$t('cityArea.areaLevel')">
                  <label v-if="cityAreaInfo.areaLevel == '101'">{{ $t('cityArea.province') }}</label>
                  <label v-else-if="cityAreaInfo.areaLevel == '202'">{{ $t('cityArea.city') }}</label>
                  <label v-else-if="cityAreaInfo.areaLevel == '303'">{{ $t('cityArea.district') }}</label>
                  <label v-else>{{ $t('cityArea.area') }}</label>
                </el-form-item>
              </el-col>
              <el-col :sm="8" :xs="24">
                <el-form-item :label="$t('cityArea.parentAreaCode')">
                  <label>{{ cityAreaInfo.parentAreaCode || '-' }}</label>
                </el-form-item>
              </el-col>
              <el-col :sm="8" :xs="24">
                <el-form-item :label="$t('cityArea.parentAreaName')">
                  <label>{{ cityAreaInfo.parentAreaName || '-' }}</label>
                </el-form-item>
              </el-col>
              <el-col :sm="8" :xs="24">
                <el-form-item :label="$t('cityArea.createTime')">
                  <label>{{ cityAreaInfo.createTime || '-' }}</label>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import CityAreaTree from '@/components/shop/cityAreaTree/cityAreaTree'
import { listAreas } from '@/api/shop/cityAreaApi'

export default {
  name: 'CityArea',
  components: {
    CityAreaTree
  },
  data() {
    return {
      cityAreaInfo: {
        id: '',
        areaCode: '',
        areaName: '',
        areaLevel: '',
        parentAreaCode: '',
        parentAreaName: '',
        createTime: ''
      }
    }
  },
  methods: {
    handleSwitchCityArea(params) {
      this.cityAreaInfo.id = params.id
      this.cityAreaInfo.areaCode = params.areaCode
      this.cityAreaInfo.areaName = params.areaName
      this.listCityArea()
    },
    listCityArea() {
      const params = {
        page: 1,
        row: 1,
        areaCode: this.cityAreaInfo.areaCode,
        id: this.cityAreaInfo.id
      }

      listAreas(params).then(response => {
        const data = response.data
        if (data && data.length > 0) {
          this.cityAreaInfo = { ...this.cityAreaInfo, ...data[0] }
        }
      }).catch(error => {
        console.error('获取地区详情失败:', error)
      })
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.white-bg {
  background: #fff;
}

.padding-left {
  padding-left: 15px;
}

.padding-right {
  padding-right: 15px;
}

.padding-top {
  padding-top: 15px;
}

.border-radius-top {
  border-radius: 4px 4px 0 0;
}

.margin-top {
  margin-top: 15px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.text-title {
  font-size: 16px;
  font-weight: bold;
}
</style>